class SwipeControl extends HTMLElement {
    /**
     * @type {import('../swipe-area/swipe-area.js').default}
     */
    _swipeArea;

    /**
     * @type {HTMLButtonElement}
     */
    _prevButton;

    /**
     * @type {HTMLButtonElement}
     */
    _nextButton;

    connectedCallback() {
        this._swipeArea = document.querySelector(`#${this.dataset.target}`);
        this._swipeArea.addEventListener('scroll', this);
        // @ts-ignore
        [this._prevButton, this._nextButton] = this.children;

        this._prevButton.addEventListener('click', this);
        this._nextButton.addEventListener('click', this);

        this.update();
    }

    update() {
        this._prevButton.disabled = this._swipeArea.isSelectedFirst;
        this._nextButton.disabled = this._swipeArea.isSelectedLast;
    }

    /**
     * @param {Event} event
     */
    handleEvent(event) {
        switch (event.currentTarget) {
            case this._prevButton:
                return this._swipeArea.swipe(-1);

            case this._nextButton:
                return this._swipeArea.swipe();

            case this._swipeArea:
                return this.update();
        }
    }
}

customElements.define('swipe-control', SwipeControl);
export default SwipeControl;
